import { sumBy } from 'lodash'

export default (connectorData: any) => {
  return {
    // @ts-expect-error
    totalSent: sumBy(connectorData, item => item.sentNotifications),
    // @ts-expect-error
    totalViewed: sumBy(connectorData, item => item.viewedNotifications),
    // @ts-expect-error
    totalDetailsViewed: sumBy(connectorData, item => item.detailViewed),
    // @ts-expect-error
    totalClicks: sumBy(connectorData, item => item.clickThroughRate)
  }
}
